export const RESULT_CONSTANT = 'RESULT_CONSTANT';
